import { createReducer, on } from '@ngrx/store';
import { findLast } from 'lodash';

import { ISiteState } from '@shared/types/site';

import { set_iframe_mode } from '../actions/session.action';
import {
    add_sites,
    add_sites_success,
    get_recent_sites_success,
    get_sites,
    get_sites_failure,
    get_sites_success,
    remember_selected_sites,
    site_selection,
    site_selection_from_portal,
    site_selection_success,
    update_prev_selected_sites,
    update_site_selection,
    update_site_selection_failure,
    update_site_selection_success,
} from '../actions/sites.action';

const initialState: ISiteState = {
    sites: [],
    prevSelectedSites: [],
    prevSelectedSite: null,
    selectedSites: [],
    selectedSite: null,
    enablePicker: false,
    isSelectionUpdated: false,
    iframePostMessageResult: null,
    hierarchyId: null,
    XCATSubscriptionStoreSelected: false,
};

const _sitesReducer = createReducer(
    initialState,

    on(get_sites, (state): ISiteState => state),
    on(
        get_sites_success,
        (state, { sites, prevSelectedSite, prevSelectedSites }): ISiteState => ({
            ...state,
            sites,
            prevSelectedSite,
            prevSelectedSites,
        }),
    ),
    on(get_sites_failure, (state): ISiteState => state),

    on(get_recent_sites_success, (state): ISiteState => ({ ...state, enablePicker: true })),
    on(site_selection, (state): ISiteState => state),
    on(
        site_selection_success,
        (state, { msg }): ISiteState => ({
            ...state,
            enablePicker: true,
            isSelectionUpdated: true,
            iframePostMessageResult: { ...msg },
        }),
    ),
    on(site_selection_from_portal, (state, { payload }): ISiteState => {
        const isMultiple = payload.isMultiple;
        const sites = payload.payload.items.map((item) =>
            findLast(state.sites, (allSitesItem) => allSitesItem.id === item.id),
        );
        const hierarchyId = payload.payload.hierarchyId;
        const XCATSubscriptionStoreSelected = payload.payload.items?.some((item) =>
            item.subscriptions_data?.some((sub) => sub.product === 'xcat'),
        );
        return {
            ...state,
            [isMultiple ? 'selectedSites' : 'selectedSite']: isMultiple ? sites : sites[0],
            isSelectionUpdated: true,
            hierarchyId,
            XCATSubscriptionStoreSelected,
        };
    }),
    on(update_prev_selected_sites, (state, { prevSelectedSite, prevSelectedSites, isMultiple }): ISiteState => {
        return {
            ...state,
            [isMultiple ? 'prevSelectedSites' : 'prevSelectedSite']: isMultiple ? prevSelectedSites : prevSelectedSite,
        };
    }),
    on(set_iframe_mode, (state, { isIframeMode }): ISiteState => ({ ...state, enablePicker: isIframeMode })),

    on(add_sites, (state): ISiteState => ({ ...state, isSelectionUpdated: false })),
    on(add_sites_success, (state, { sites }): ISiteState => {
        const XCATSubscriptionStoreSelected = sites.some((item) => item.subscriptions.some((sub) => sub === 'xcat'));
        return {
            ...state,
            sites,
            selectedSites: sites,
            selectedSite: sites[0],
            isSelectionUpdated: true,
            XCATSubscriptionStoreSelected,
        };
    }),

    on(update_site_selection, (state): ISiteState => state),

    on(
        update_site_selection_success,
        (state, { isMultiple, prevSelectedSites, prevSelectedSite, sites }): ISiteState => {
            let XCATSubscriptionStoreSelected = false;
            if (sites?.length) {
                XCATSubscriptionStoreSelected = isMultiple
                    ? sites.some((item) => item.subscriptions?.some((sub) => sub === 'xcat'))
                    : sites[0].subscriptions?.some((sub) => sub === 'xcat');
            }

            return {
                ...state,
                [isMultiple ? 'selectedSites' : 'selectedSite']: isMultiple ? sites : sites[0],
                [isMultiple ? 'prevSelectedSites' : 'prevSelectedSite']: isMultiple
                    ? prevSelectedSites
                    : prevSelectedSite,
                isSelectionUpdated: true,
                XCATSubscriptionStoreSelected,
            };
        },
    ),

    on(update_site_selection_failure, (state): ISiteState => state),

    on(
        remember_selected_sites,
        (state, { selectedSite, selectedSites }): ISiteState => ({
            ...state,
            selectedSite,
            selectedSites,
        }),
    ),
);

export function sitesReducer(state, action) {
    return _sitesReducer(state, action);
}
